<template>
  <div id="app" :class="$style.root">
    <ActList v-show="activePanel === 'act'" :items="pinTuan.items" :banner="banner" />
    <JoinedList v-show="activePanel === 'my'" :data="joined" />
    <InfiniteLoader
      v-if="hasMore"
      useDocument
      direction="bottom"
      :offset="150"
      :onTrigger="loadMore"
    >
      <!-- 自定义加载动画 -->
      <!-- <div class="u-textCenter u-marginTop10 u-marginBottom10"></div> -->
    </InfiniteLoader>
    <div :class="$style.footer">
      <div :class="[$style.atcTab, activePanel === 'act' && $style.isActive]" @click="showActTab">
        <div><i :class="$style.icon"/></div>
        <div>拼团首页</div>
      </div>
      <div :class="[$style.myTab, activePanel === 'my' && $style.isActive]" @click="showMyTab">
        <div><i :class="$style.icon"/></div>
        <div>我的拼团</div>
      </div>
    </div>
  </div>
</template>

<script>
import dev from "helper/dev";
import fectx from "helper/fectx";
import { urlQuery } from "utils/url";
import Message from "base-components/Message";
import InfiniteLoader from "base-components/InfiniteLoader";
import ActList from "./components/ActList";
import JoinedList from "./components/JoinedList";
import service from "./service";

let id = 0;
const mockGood = () => {
  return {
    Id: ++id,
    ActName: "团购1",
    ActCode: "signinlottery3" + id,
    DisplayMoney: 20.11,
    PayMoney: 0.01,
    WebId: 1498687982,
    JoinTime: "2019-05-09 08:53:39.377",
    OrderStatus: [1, 2, 3][Math.floor(Math.random() * 3)],
    MemberCount: 3,
    OrderCount: "3",
    JoinCount: 1,
    ShareDesc: "点击领取",
    ShareImage:
      "http://i1.lifevccdn.com//Upload/AppCategoryBanner/feca645b98574ce98ae080a2e358d9af.jpg",
    ShareLink:
      "http://w2.lifetest.com/1904/190405-qian-dao-chou-jiang-share.html?actcode=signinlottery3",
    ShareTitle:
      "@nickname送给你1个小米128G终极版小米128G终极版小米128G终极版小米128G终极版小米128G终极版",
  };
};
// const config = getConfig();
const PAGE_SIZE = 15;
const requestActList = page => fectx.get(`/Act/GroupOrder/Banner/${page}/${PAGE_SIZE}`);
const requestJoined = page => fectx.get(`/Act/GroupOrder/User/${page}/${PAGE_SIZE}`);

export default {
  name: "App",
  components: {
    ActList,
    JoinedList,
    InfiniteLoader,
  },
  provide() {
    return {
      resource: this.resource,
    };
  },
  data() {
    return {
      resource: {
        rule: "",
        imgGongZhongHao: "",
        linkDownload: "",
        linkShiYongZhuang: "",
        imgDownload: "",
      },
      activePanel: "act",
      dataReady: false,

      actName: "",
      pinTuan: {
        isInit: false,
        currentPage: 1,
        items: [],
        hasMore: true,
      },
      joined: {
        isInit: false,
        currentPage: 1,
        items: [],
        hasMore: true,
        loading: false,
        error: false,
      },
      banner: "",
    };
  },
  async created() {
    this.getActList({ isInit: true });
    if (urlQuery.p === "my") {
      this.showMyTab();
    }
  },
  computed: {
    hasMore() {
      return this.pinTuan.hasMore || this.joined.hasMore;
    },
  },
  methods: {
    showActTab() {
      this.activePanel = "act";
      service.setTitle(this.actName);
    },
    showMyTab() {
      this.activePanel = "my";
      service.setTitle("我的拼团");

      if (!service.isLogin()) {
        service.login(() => {
          this.getJoined({ isInit: true });
        });
        return;
      } else {
        this.getJoined({ isInit: true });
      }
    },
    async getActList({ isInit = false } = {}) {
      this.pinTuan.isInit = isInit;

      let resp;
      try {
        resp = await requestActList(this.pinTuan.currentPage);
      } catch (error) {
        Message.error("网络错误");
        return;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData);
        return;
      }
      const payload = data.InnerData;
      this.dataReady = true;
      if (this.pinTuan.isInit) {
        this.actName = payload.Banner.ActName;
        this.banner = payload.Banner.ImageUrl;

        this.resource.rule = payload.Banner.RuleString;
        this.resource.imgGongZhongHao = payload.Banner.Image1;
        this.resource.linkDownload = payload.Banner.Link2;
        this.resource.linkShiYongZhuang = payload.Banner.Link1;
        this.resource.imgDownload = payload.Banner.Image3;

        service.setTitle(this.actName);
        service.setShareData({
          title: payload.Banner.ShareTitle,
          description: payload.Banner.ShareDesc,
          imageUrl: payload.Banner.ShareImage,
          url: payload.Banner.ShareLink,
        });
      }
      if (!payload.List || payload.List.length <= 0) {
        this.pinTuan.hasMore = false;
        return;
      }

      this.pinTuan.currentPage += 1;

      // const payload = { List: [mockGood(), mockGood(), mockGood()] };
      payload.List.forEach(good => {
        this.pinTuan.items.push({
          id: good.GoodsId + good.ActCode,
          goodId: good.GoodsId,
          actCode: good.ActCode,
          webId: good.WebId,
          goodName: good.ActName,
          price: good.DisplayMoney,
          promptPrice: good.PayMoney,
          goodPreivewImage: good.ActImage1,
          peopleNeed: good.MemberCount,
          doneNum: good.OrderCount,
          isPay: good.IsPaid,

          // share
          ShareTitle: good.ShareTitle,
          ShareDesc: good.ShareDesc,
          ShareImage: good.ShareImage,
          ShareLink: good.ShareLink,
        });
      });
    },
    async getJoined({ isInit = false } = {}) {
      this.joined.isInit = isInit;

      let resp;
      try {
        this.joined.loading = true;
        resp = await requestJoined(this.joined.currentPage);
      } catch (error) {
        this.joined.error = true;
        Message.error("网络错误");
        return;
      } finally {
        this.joined.loading = false;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData);
        return;
      }
      const payload = data.InnerData;

      if (!payload.OrderList || payload.OrderList.length <= 0) {
        this.joined.hasMore = false;
        return;
      }

      this.joined.currentPage += 1;
      // const payload = { OrderList: [mockGood(), mockGood(), mockGood(), mockGood()] };
      payload.OrderList.forEach(good => {
        this.joined.items.push({
          id: good.GoodsId + good.ActCode,
          goodId: good.GoodsId,
          actCode: good.ActCode,
          webId: good.WebId,
          goodName: good.ActName,
          price: good.DisplayMoney,
          promptPrice: good.PayMoney,
          goodPreivewImage: good.ActImage1,
          peopleNeed: good.MemberCount,
          peopleJoined: good.JoinCount,
          doneNum: good.OrderCount,
          remainTime: good.LeftTime,
          status: good.OrderStatus,
          time: good.JoinTime,
          isPay: good.IsPaid,
          isSendCoupon: good.IsSendCoupon,

          // share
          ShareTitle: good.ShareTitle,
          ShareDesc: good.ShareDesc,
          ShareImage: good.ShareImage,
          ShareLink: good.ShareLink,
        });
      });
    },
    async loadMore(finish) {
      try {
        if (this.activePanel === "act") {
          await this.getActList();
        } else {
          await this.getJoined();
        }
      } finally {
        finish();
      }
    },
  },
};
</script>

<style lang="scss" module>
// ！为了使用 rem 单位每个vue组件都要导入
$page-width: 375;
@import "~style/tool";
.root {
  padding-bottom: rem(60px);
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: rem(60px);
  border-top: 1px solid rgba(223, 223, 223, 1);
  background: rgba(255, 255, 255, 1);
}
.tab {
  width: 50%;
  text-align: center;
  font-size: rem(11px);
  color: rgba(51, 51, 51, 1);
  .icon {
    position: relative;
    top: rem(4);
    display: inline-block;
    width: rem(25);
    height: rem(25);
    background-size: 100%;
  }
}
.isActive.tab {
  color: rgba(233, 91, 82, 1);
}
.atcTab {
  composes: tab;
  .icon {
    background-image: url("./assets/icon/home.png");
  }
}
.isActive.atcTab .icon {
  background-image: url("./assets/icon/home-active.png");
}
.myTab {
  position: relative;
  composes: tab;
  // &::after {
  //   content: "";
  //   position: absolute;
  //   height: rem(15);
  //   top: rem(5);
  //   left: 0;
  //   width: 1px;
  //   background: rgba(216, 216, 216, 1);
  // }
  .icon {
    background-image: url("./assets/icon/my.png");
  }
}
.isActive.myTab .icon {
  background-image: url("./assets/icon/my-active.png");
}
// end
</style>
